import { render } from "./order-item.vue?vue&type=template&id=6d76793c&scoped=true&ts=true"
import script from "./order-item.vue?vue&type=script&lang=ts"
export * from "./order-item.vue?vue&type=script&lang=ts"

import "./order-item.vue?vue&type=style&index=0&id=6d76793c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d76793c"]])

export default __exports__